module.exports = __webpack_public_path__ + "img/doc.c719bb75.svg";